export enum PersonKind {
  SINGLE = 'SINGLE',
  HUSBAND = 'HUSBAND',
  WIFE = 'WIFE',
  CHILD = 'CHILD',
  OTHER = 'OTHER',
}
